export default __webpack_public_path__ + "static/media/ion_airplane_white.3d2aab82.svg";